module.exports = __webpack_public_path__ + "img/vue-dischi.42bf4377.png";